/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { LocalStorange } from '../environment';

export interface IAuthContextData {
    isAuthenticated: boolean;
    handleSignIn: (userInfo: any) => Promise<string | void>;
    handleSignOut: () => void;
}

const AuthContext = createContext({} as IAuthContextData);

interface IAuthProviderProps {
    children: React.ReactNode;
}

export const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
    const [userInfo, setUserInfo] = useState<any>();
    const [isAuthenticated, setIsAuthenticate] = useState(false);

    useEffect(() => {
        let userInfo = localStorage.getItem(LocalStorange.USERINFO);

        if (userInfo) {
            userInfo = JSON.parse(userInfo);

            setUserInfo(userInfo);
            setIsAuthenticate(true);
        }
    }, [isAuthenticated]);

    const handleSignIn = useCallback(async (userInfo: any) => {

        localStorage.removeItem(LocalStorange.USERINFO); //validar se é necesario

        setUserInfo(userInfo);
        setIsAuthenticate(oldValue => !oldValue);

        localStorage.setItem(LocalStorange.USERINFO, JSON.stringify(userInfo));
    }, []);

    const handleSignOut = useCallback(() => {

        setIsAuthenticate(oldValue => !oldValue);

        localStorage.removeItem(LocalStorange.USERINFO);
    }, []);

    useMemo(() => {

        if (userInfo && isAuthenticated) {
            const now = new Date();
            const tokenExpirationDateTime = new Date(userInfo.user.tokenExpirationDateTime);

            if (tokenExpirationDateTime >= now) {
                setIsAuthenticate(true);
            }
            else {
                setUserInfo(undefined);
                setIsAuthenticate(false);

                localStorage.removeItem(LocalStorange.USERINFO);
            }
        }
        else {
            setUserInfo(undefined);
        }
    }, [isAuthenticated]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, handleSignIn, handleSignOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => useContext(AuthContext);